import { useState } from 'react';
import { showToast } from '@/components/base/Toast';

const NAV_LINKS = [
  { href: '#home', label: '首页' },
  { href: '#ranking', label: '热度榜' },
  { href: '#albums', label: '写真集' },
  { href: '#videos', label: 'cos视频' },
  { href: '#sets', label: '私拍套图' },
];

export default function SiteHeader() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [keyword, setKeyword] = useState('');

  const handleSearch = () => {
    if (!keyword.trim()) {
      showToast('试试搜索「白衬衫」「眼镜」等关键词');
      return;
    }
    showToast(`已记录搜索：${keyword.trim()}`);
  };

  return (
    <header className="sticky top-0 z-50 w-full border-b border-background-200 bg-background-50/90 backdrop-blur-md">
      <div className="w-full px-4 md:px-8">
        <div className="flex h-16 items-center justify-between gap-4 md:h-[68px]">
          <a href="#home" className="flex items-center gap-3">
            <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary-500 text-background-50">
              <i className="ri-quill-pen-line text-xl" />
            </span>
            <span className="flex flex-col leading-tight">
              <span className="font-heading text-base font-bold tracking-tight text-foreground-950">
                善良的女秘书
              </span>
              <span className="text-[11px] tracking-widest text-secondary-600">
                角色扮演视觉资源库
              </span>
            </span>
          </a>

          <nav className="hidden items-center gap-1 lg:flex">
            {NAV_LINKS.map((link) => (
              <a
                key={link.href}
                href={link.href}
                className="rounded-md px-3 py-2 text-sm font-medium text-foreground-700 transition-colors duration-200 hover:bg-background-100 hover:text-primary-700"
              >
                {link.label}
              </a>
            ))}
          </nav>

          <div className="hidden items-center gap-2 md:flex">
            <div className="flex items-center gap-2 rounded-md border border-background-300 bg-background-100 px-3 py-2">
              <i className="ri-search-line text-base text-foreground-500" />
              <input
                value={keyword}
                onChange={(event) => setKeyword(event.target.value)}
                onKeyDown={(event) => {
                  if (event.key === 'Enter') {
                    handleSearch();
                  }
                }}
                placeholder="搜索写真 / 视频 / 套图"
                className="w-36 bg-transparent text-sm text-foreground-800 placeholder:text-foreground-500 focus:outline-none lg:w-44"
              />
            </div>
            <button
              type="button"
              onClick={() => showToast('已加入收藏，感谢支持')}
              className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2.5 text-sm font-medium text-background-50 transition-colors duration-200 hover:bg-primary-600"
            >
              <i className="ri-bookmark-line text-base" />
              收藏本站
            </button>
          </div>

          <button
            type="button"
            onClick={() => setMenuOpen((open) => !open)}
            className="flex h-10 w-10 items-center justify-center rounded-md border border-background-300 text-foreground-800 md:hidden"
            aria-label="展开菜单"
          >
            <i className={menuOpen ? 'ri-close-line text-xl' : 'ri-menu-line text-xl'} />
          </button>
        </div>
      </div>

      {menuOpen ? (
        <div className="border-t border-background-200 bg-background-50 px-4 pb-5 pt-3 md:hidden">
          <nav className="flex flex-col gap-1">
            {NAV_LINKS.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={() => setMenuOpen(false)}
                className="rounded-md px-3 py-2.5 text-sm font-medium text-foreground-700 hover:bg-background-100"
              >
                {link.label}
              </a>
            ))}
          </nav>
          <div className="mt-3 flex items-center gap-2 rounded-md border border-background-300 bg-background-100 px-3 py-2">
            <i className="ri-search-line text-base text-foreground-500" />
            <input
              value={keyword}
              onChange={(event) => setKeyword(event.target.value)}
              placeholder="搜索写真 / 视频 / 套图"
              className="w-full bg-transparent text-sm text-foreground-800 placeholder:text-foreground-500 focus:outline-none"
            />
          </div>
          <button
            type="button"
            onClick={() => showToast('已加入收藏，感谢支持')}
            className="mt-3 flex w-full items-center justify-center gap-1.5 rounded-md bg-primary-500 px-4 py-2.5 text-sm font-medium text-background-50"
          >
            <i className="ri-bookmark-line text-base" />
            收藏本站
          </button>
        </div>
      ) : null}
    </header>
  );
}